export default __webpack_public_path__ + "static/service-mesh-patterns-95b450fd6417632e73ffb7dbd6f3ce3e.webp";